import { LanguageOptions } from '@blocknox/flow';
import { LanguageCode } from '@/i18n/config';
import { useTranslation } from 'react-i18next';
import { i18n as i18nType, TFunction } from 'i18next';
import i18n from 'i18next';

const getLanguage = (source?: i18nType): string | undefined => {
  return source?.language ?? i18n.language;
};

export const getLocale = (source?: i18nType): LanguageOptions => {
  return getLanguage(source)?.toLowerCase().startsWith('de') ? LanguageCode.DE : LanguageCode.EN;
};

export const useLocale = (): {
  t: TFunction<'translation', undefined>;
  i18n: i18nType;
  locale: LanguageOptions;
  isGerman: boolean;
} => {
  const { i18n, t } = useTranslation(); // subscribe to language changes so getLocale() re-reads on language switch
  const locale = getLocale(i18n);
  return {
    t: t,
    i18n: i18n,
    locale: locale,
    isGerman: locale === LanguageCode.DE
  };
};
